/** The one wording of the environment's edit kill switch (DESIGN.md One-Wording Rule): every
 *  record's Actions-menu note, blocked Edit and field reason says it the same way — bookings,
 *  orders, users and the catalog records alike. */
export const EDITING_OFF = 'Editing is switched off';
